import React, {useEffect, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {Container, Typography, Box, Alert} from '@mui/material';
import AuthForm from '../components/AuthForm';
import {login, isAuthenticated} from '../services/auth';
import {Image} from "@mui/icons-material";

const Login: React.FC = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean | null>(null);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (isAuthenticated()) {
            navigate('/');
        }
    }, [navigate]);

    const handleLogin = async (data: { email: string; password: string }) => {
        try {
            setLoading(true)
            await login(data.email, data.password);
            setLoading(false)
            navigate('/dashboard');
        } catch (error: any) {
            setError(error.response.data.detail)
            setLoading(false)
            console.error('Login failed:', error);
        }
    };

    return (
        <Box sx={{display: 'flex', alignItems:'center', height: '100vh', backgroundImage: 'url(333.webp)', backgroundSize: '300px auto'}}>
            {/* Левая часть с фоновым изображением */}
            <Container component="main" maxWidth="xs" style={{backgroundColor: '#fff'}}>
                <Box sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    height: 'auto'
                }}>
                    <Box sx={{mt: 6, mb: 3}}>
                        <Typography component="h3" variant="h3">
                            Self Detailing
                        </Typography>
                    </Box>
                    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <Typography component="h1" variant="h5">
                            Авторизация
                        </Typography>

                        <AuthForm onSubmit={handleLogin} buttonText="Войти" loading={loading} error={error}/>
                        {error && <Alert severity="error"
                                         sx={{width: "100%", boxSizing: 'border-box', mt: 1}}>{error}</Alert>}
                        <Box sx={{mt: 3, display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                            <Link style={{paddingLeft: '0px'}} to="/forgot-password">Забыли пароль?</Link>
                            <Link style={{paddingLeft: '0px'}} to="/register">Зарегистрироваться</Link>
                        </Box>
                    </Box>
                    <Box sx={{
                        mb: 4,
                        mt: 5,
                        display: 'block',
                        justifyContent: 'space-between',
                        width: '100%',
                        textAlign: 'center',
                        color: '#888'
                    }}>
                        © {new Date().getFullYear()} г.
                    </Box>

                </Box>
            </Container>
        </Box>
    );
};

export default Login;
